<main class="projects-list-page container">
  <h1 class="projects-list-page__header">
    {{ 'global.projects' | translate }}
  </h1>

  <div class="projects-list-page__content">
    <div class="projects-list-page__main">
      @if (!isLoading) {
        <pwj-sorts-bar
          class="projects-list-page__sort-bar"
          variant="segmented"
          [sorts]="sortItems"
          translateKey="sorting.people."
          sortParamKey="sort"
          [haveInitializeTab]="false"
          [resultsCount]="allProjectsCount" />
      } @else {
        <div class="projects-list-page__sort-bar-skeleton" aria-hidden="true">
          <div class="projects-list-page__sort-bar-skeleton-inner">
            <ngx-skeleton-loader
              count="1"
              class="projects-list-page__sort-bar-skeleton-tabs"
              [theme]="{
                width: '100%',
                height: '2.375rem',
                'border-radius': '0.5rem',
                margin: '0',
              }"></ngx-skeleton-loader>
            <div class="projects-list-page__sort-bar-skeleton-meta">
              <ngx-skeleton-loader
                count="1"
                [theme]="{
                  width: '4.5rem',
                  height: '0.875rem',
                  'border-radius': '0.25rem',
                  margin: '0',
                }"></ngx-skeleton-loader>
            </div>
          </div>
        </div>
      }

      <div class="projects-list-page__cards">
        @if (!isLoading) {
          @if (projectsData.length > 0) {
            <ul class="products-list">
              @for (project of projectsData; track project._id) {
                <li>
                  <pwj-project-card [data]="project" />
                </li>
              }
            </ul>
          } @else {
            <pwj-no-content message="projects.noProjects" />
          }
        } @else {
          <ul class="products-list">
            <pwj-project-card-skeleton [count]="6" [wrapInListItem]="true" />
          </ul>
        }
      </div>

      @if (allProjectsCount && allProjectsCount > 6) {
        <div>
          <pwj-pagination [dataCount]="allProjectsCount" [perPage]="6" />
        </div>
      }
    </div>
  </div>
</main>
